import { STRINGS } from "@/i18n";

/** Formats a number in the site's locale (comma as decimal separator) with fixed decimals. */
export function formatNumber(value: number, decimals: number = 2): string {
  return value.toLocaleString(STRINGS.locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/** Formats an amount in euros in the site's locale, e.g. "€0,1234" (nl) or "0,1234 €" (fr). */
export function formatEuro(value: number, decimals: number = 2): string {
  return STRINGS.euro(formatNumber(value, decimals));
}

/** Formats a spot-price coefficient without padding zeros, e.g. "1,02". */
export function formatCoefficient(value: number): string {
  return value.toLocaleString(STRINGS.locale, { maximumFractionDigits: 4 });
}

/** Formats a YYYY-MM-DD key as a long local date, e.g. "23 oktober 2026". */
export function formatDateLabel(dateKey: string): string {
  const [year, month, day] = dateKey.split("-").map(Number);
  if (!year || !month || !day) return dateKey;
  return new Date(year, month - 1, day).toLocaleDateString(STRINGS.locale, {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}
